/**
 * Ids of the use cases this user has run, in the order they first ran them. Written by
 * {@link markChatUseCaseUsed} and read by the surfaces that sort already-tried use cases last.
 *
 * Lives apart from useCaseUsage so Preferences can register its default without importing the
 * module that reads Preferences.
 */
export const USED_CHAT_USE_CASES_PREFERENCE_KEY = 'LLM_USED_USE_CASES';
